export default theme => ({
    button:{
        backgroundColor:"#ff7800",
        color:"white",
        
    },
    refreshButton:{
        width:"100%"
        
    }
  });
  
  


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlObjective/WindowModalDelete/styles.jsx